import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AlertMessage from "../../AlertMessage";
import { QRCodeCanvas } from "qrcode.react";
import { getDatabase, ref, set, push ,get} from "firebase/database";
import firebase, {storage} from '../firebase'

function AdmissionData() {
  const [admissionData, setAdmissionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [classUpdates, setClassUpdates] = useState({});
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const language = localStorage.getItem("language");

  const [newClass, setNewClass] = useState(""); // State for new class input
  const [classes, setClasses] = useState([]); // State for classes


  // Fetch admission data
  const fetchAdmissionData = async () => {
    try {
      if (!udiseNumber) return;

      const response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/AdmissionFrom.json`
      );

      const data = response.data;
      const admissionsArray = [];

      if (data) {
        for (const key in data) {
          const item = data[key];
          if (item && typeof item === "object") {
            admissionsArray.push({
              ...item,
              id: key,
              registerNo: item.registerNo || "",
            });
          }
        }
      }

      setAdmissionData(admissionsArray);
    } catch (error) {
      console.error("Error fetching admission data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterNoChange = (id, value) => {
    setAdmissionData((prev) =>
      prev.map((student) =>
        student.id === id ? { ...student, registerNo: value } : student
      )
    );
  };

  useEffect(() => {
    fetchAdmissionData();
    fetchSchoolData();
  }, [udiseNumber]);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  const [schoolData, setSchoolData] = useState("");

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open("SchoolManagementDB", 1);

      request.onerror = (event) => {
        console.error("Database error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains("studentData")) {
          db.createObjectStore("studentData", { keyPath: "id" });
        }
        if (!db.objectStoreNames.contains("schoolData")) {
          db.createObjectStore("schoolData", { keyPath: "udiseNumber" }); // Ensure this matches your key
        }
      };
    });
  };

  const fetchSchoolData = async () => {
    if (!udiseNumber) {
      console.error("UDISE number is not defined.");
      return;
    }

    try {
      const request = indexedDB.open("SchoolManagementDB", 1);
      request.onsuccess = async (event) => {
        const db = event.target.result;
        const transaction = db.transaction(["schoolData"], "readonly");
        const objectStore = transaction.objectStore("schoolData");
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
          }
          setLoading(false);
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
          setLoading(false);
        };
      };

      request.onerror = (event) => {
        console.error("Error opening IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error fetching school data:", error);
      setLoading(false);
    }
  };


const [packType, setPackType] = useState("freeTrial");
const [studentLimit, setStudentLimit] = useState(10);

useEffect(() => {
  if (udiseNumber) {
    const dbRef = firebase.database().ref(`/Admin/${udiseNumber}`);
    dbRef.once("value")
      .then((snapshot) => {
        const data = snapshot.val();
        const pack = data?.packActivated || "freeTrial";
        setPackType(pack);

        switch (pack) {
          case "silver":
            setStudentLimit(100);
            break;
          case "gold":
            setStudentLimit(500);
            break;
          case "platinum":
            setStudentLimit(1000);
            break;
          case "platinum plus":
            case undefined:
            case null:
            case "purchase":
            case "":
            case "freeTrial": // If you want free trial to also have unlimited
              setStudentLimit(Infinity); // Unlimited students
              break;
          default:
            setStudentLimit(10);
        }
      })
      .catch((error) => {
        console.error("Error fetching pack activation status:", error);
      });
  }
}, [udiseNumber]);

 const handleSaveStudent = async (student) => {
  try {
    if (!student.registerNo || !student.stdName || !student.currentClass) {
      setAlertMessage(
        "Please fill in all required fields: Register No, Student Name, Current Class."
      );
      return;
    }

    // Step 1: Check student limit before proceeding
    try {
      const lastSerialRes = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lastAddedSerialNo.json`
      );
      if (!lastSerialRes.ok) {
        setAlertMessage("Failed to fetch last serial number.");
        return;
      }
      const lastSerial = await lastSerialRes.json();

      if (lastSerial >= studentLimit) {
        setAlertMessage(
          `Your current plan (${packType}) allows only up to ${studentLimit} students.`
        );
        return;
      }
    } catch (error) {
      console.error("Error checking student limit:", error);
      setAlertMessage("Could not verify student limit.");
      return;
    }

    // Step 2: Assign serial number if not present
    let serialNo = student.serialNo;
    if (!serialNo) {
      const lastSerialRes = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lastAddedSerialNo.json`
      );
      const lastSerial = await lastSerialRes.json();
      serialNo = lastSerial ? lastSerial + 1 : 1;
      student.serialNo = serialNo;
    }

    // Step 3: Prepare and save to Firebase
    const firebasePath = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${serialNo}.json`;
    const { id, ...studentDataWithoutId } = student;

    const saveStudentRes = await fetch(firebasePath, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(studentDataWithoutId),
    });

    if (!saveStudentRes.ok) {
      setAlertMessage("Failed to store student data to Firebase.");
      return;
    }

    // Step 4: Update lastAddedSerialNo
    await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lastAddedSerialNo.json`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(serialNo),
      }
    );

    // Step 5: Save to IndexedDB
    const db = await openIndexedDB();
    const transaction = db.transaction("studentData", "readwrite");
    const objectStore = transaction.objectStore("studentData");
    const key = `${student.currentClass}--${serialNo}`;
    const getRequest = objectStore.get(key);

    getRequest.onsuccess = async () => {
      const existing = getRequest.result;
      const updatedData = existing ? { ...existing, ...student } : student;
      const putRequest = objectStore.put({ ...updatedData, id: key });

      putRequest.onsuccess = async () => {
        try {
          const deleteResponse = await axios.delete(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/AdmissionFrom/${student.id}.json`
          );
          if (deleteResponse.status === 200) {
            setAlertMessage("✅ Student data saved and admission form deleted successfully.");
            setAdmissionData((prev) =>
              prev.filter((s) => s.id !== student.id)
            );
          } else {
            setAlertMessage("✅ Student saved but failed to delete admission form.");
          }
        } catch (deleteError) {
          console.error("Error deleting admission form:", deleteError);
          setAlertMessage("✅ Student saved but error deleting admission form.");
        }
      };

      putRequest.onerror = (e) => {
        console.error("Error storing to IndexedDB:", e.target.error);
        setAlertMessage("❌ Failed to save data to local storage.");
      };
    };

    getRequest.onerror = (e) => {
      console.error("Error reading IndexedDB record:", e.target.error);
      setAlertMessage("❌ Failed to access local storage.");
    };

    // Step 6: Update classDiv in localStorage
    const classtosave = student.currentClass;
    const classDivData = JSON.parse(localStorage.getItem("classDiv")) || {};
    if (!classDivData[classtosave]) {
      classDivData[classtosave] = true;
    }
    localStorage.setItem("classDiv", JSON.stringify(classDivData));

  } catch (error) {
    console.error("Error in handleSaveStudent:", error);
    setAlertMessage("An unexpected error occurred.");
  }
};


  const handleRemoveStudent = async (studentId) => {
    if (
      window.confirm("Are you sure you want to delete this admission record?")
    ) {
      try {
        const deleteResponse = await axios.delete(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/AdmissionFrom/${studentId}.json`
        );

        if (deleteResponse.status === 200) {
          setAlertMessage("✅ Admission record deleted successfully.");
          setAdmissionData((prev) => prev.filter((s) => s.id !== studentId));
        } else {
          setAlertMessage("❌ Failed to delete admission record.");
        }
      } catch (error) {
        console.error("Error deleting admission record:", error);
        setAlertMessage("❌ An error occurred while deleting the record.");
      }
    }
  };

  
   const fetchClasses = async () => {
    try {
      if (!udiseNumber) return;
      const response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/classDiv.json`
      );
      const data = response.data || {};
      const classesArray = Object.keys(data).map(key => ({ name: key }));
      setClasses(classesArray);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  useEffect(() => {
       fetchClasses();
  }, [udiseNumber]);
  
   const handleSaveClass = async () => {
    if (!newClass) {
      setAlertMessage("Please enter a class name.");
      return;
    }
    try {
      await axios.put(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/classDiv/${newClass}.json`,
        { name: newClass }
      );
      setAlertMessage("Class saved successfully.");
      setNewClass(""); // Clear input
      fetchClasses(); // Refresh class list
    } catch (error) {
      console.error("Error saving class:", error);
      setAlertMessage("Failed to save class.");
    }
  };

  

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        }}
      >
        <div
          style={{
            padding: "40px",
            background: "white",
            borderRadius: "10px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "50px",
              height: "50px",
              border: "5px solid #f3f3f3",
              borderTop: "5px solid #B22234",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 20px",
            }}
          ></div>
          <h3 style={{ color: "#143625", marginBottom: "10px" }}>
            Loading Admission Data
          </h3>
          <p style={{ color: "#7f8c8d" }}>
            Please wait while we fetch the records...
          </p>
        </div>
      </div>
    );

  const printForm = (formData) => {
    const printWindow = window.open("", "_blank");

    if (!printWindow) {
      console.error("Failed to open window.");
      return;
    }

    printWindow.document.write(`
    <html>
      <head>
        <title>Admission Form</title>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');
          
          body {
            font-family: 'Poppins', sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f5f7fa;
            color: #333;
            line-height: 1.6;
          }
          
          .container {
            width: 210mm;
            min-height: 297mm;
            margin: 0 auto;
            padding: 15mm;
            background: white;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          }
          
          .header {
            text-align: center;
            margin-bottom: 20px;
            border-bottom: 2px solid #3f51b5;
            padding-bottom: 15px;
            position: relative;
          }
          
          .school-logo {
            height: 80px;
            margin-bottom: 10px;
          }
          
          h1 {
            color: #3f51b5;
            margin: 5px 0;
            font-size: 28px;
            font-weight: 600;
          }
          
          h2 {
            color: #555;
            margin: 5px 0;
            font-size: 22px;
            font-weight: 500;
          }
          
          .school-info {
            color: #666;
            font-size: 14px;
            margin: 5px 0;
          }
          
          .form-section {
            margin-bottom: 20px;
            page-break-inside: avoid;
          }
          
          .section-title {
            background-color: #3f51b5;
            color: white;
            padding: 8px 15px;
            margin: 15px 0 10px 0;
            font-size: 16px;
            font-weight: 500;
            border-radius: 4px;
          }
          
          .form-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
            gap: 10px;
          }
          
          .form-field {
            margin-bottom: 8px;
            display: flex;
            align-items: flex-start;
          }
          
          .form-field label {
            font-weight: 500;
            color: #555;
            min-width: 180px;
            display: inline-block;
          }
          
          .form-field .value {
            flex: 1;
            word-break: break-word;
          }
          
          .student-photo {
            float: right;
            margin: 0 0 15px 15px;
            border: 1px solid #ddd;
            padding: 3px;
            width: 100px;
            height: 120px;
            object-fit: cover;
          }
          
          .watermark {
            position: absolute;
            opacity: 0.1;
            font-size: 80px;
            font-weight: bold;
            color: #3f51b5;
            transform: rotate(-30deg);
            top: 50%;
            left: 20%;
            z-index: -1;
          }
          
          @media print {
            body {
              background: none;
            }
            .container {
              box-shadow: none;
              padding: 0;
              width: auto;
            }
            .watermark {
              opacity: 0.15;
            }
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="watermark">${
            schoolData.schoolName?.substring(0, 10) || "ADMISSION"
          }</div>
          
          <div class="header">
            ${
              schoolData.schoolLogo &&
              `
              <img src="${schoolData.schoolLogo}" alt="School Logo" class="school-logo">
            `
            }
            <h1>${
              language === "English" ? "Admission Form" : "प्रवेश अर्ज"
            }</h1>
            <h2>${schoolData.schoolName || ""}</h2>
            <div class="school-info">${schoolData.address || ""}</div>
            <div class="school-info">
              ${language === "English" ? "Taluka" : "तालुका"}: ${
      schoolData.taluka || ""
    }, 
              ${language === "English" ? "District" : "जिल्हा"}: ${
      schoolData.district || ""
    }
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${
              language === "English" ? "Basic Information" : "बेसिक माहिती"
            }</div>
            <div class="form-grid">
              <div class="form-field">
                <label>APAR ID:</label>
                <div class="value">${formData.aparId || ""}</div>
              </div>
              <div class="form-field">
                <label>PAN ID:</label>
                <div class="value">${formData.panId || ""}</div>
              </div>
              <div class="form-field">
                <label>Educational Year:</label>
                <div class="value">${formData.educationalYear || ""}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${
              language === "English"
                ? "Personal Information"
                : "वैयक्तिक माहिती"
            }</div>
            <img src="${
              formData.stdPhoto || ""
            }" alt="Student Photo" class="student-photo">
            <div class="form-grid">
              <div class="form-field">
                <label>Surname:</label>
                <div class="value">${formData.stdSurname || ""}</div>
              </div>
              <div class="form-field">
                <label>Student's Name:</label>
                <div class="value">${formData.stdName || ""}</div>
              </div>
              <div class="form-field">
                <label>Father's Name:</label>
                <div class="value">${formData.stdFather || ""}</div>
              </div>
              <div class="form-field">
                <label>Mother's Name:</label>
                <div class="value">${formData.stdMother || ""}</div>
              </div>
              <div class="form-field">
                <label>Aadhar Number:</label>
                <div class="value">${formData.stdAdharNo || ""}</div>
              </div>
              <div class="form-field">
                <label>Gender:</label>
                <div class="value">${formData.gender || ""}</div>
              </div>
              <div class="form-field">
                <label>Date of Birth:</label>
                <div class="value">${formData.dob || ""}</div>
              </div>
              <div class="form-field">
                <label>Birth Place:</label>
                <div class="value">${formData.birthPlace || ""}</div>
              </div>
              <div class="form-field">
                <label>Blood Group:</label>
                <div class="value">${formData.bloodGroup || ""}</div>
              </div>
              <div class="form-field">
                <label>Birthmark:</label>
                <div class="value">${formData.birthmark || ""}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${
              language === "English"
                ? "Demographic Information"
                : "लोकसंख्यात्मक माहिती"
            }</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Religion:</label>
                <div class="value">${formData.religion || ""}</div>
              </div>
              <div class="form-field">
                <label>Caste:</label>
                <div class="value">${formData.caste || ""}</div>
              </div>
              <div class="form-field">
                <label>Sub-Caste:</label>
                <div class="value">${formData.subCaste || ""}</div>
              </div>
              <div class="form-field">
                <label>Category:</label>
                <div class="value">${formData.category || ""}</div>
              </div>
              <div class="form-field">
                <label>Nationality:</label>
                <div class="value">${formData.nationality || ""}</div>
              </div>
              <div class="form-field">
                <label>Mother Tongue:</label>
                <div class="value">${formData.motherTounge || ""}</div>
              </div>
              <div class="form-field">
                <label>Is Minority:</label>
                <div class="value">${formData.isMinority ? "Yes" : "No"}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${
              language === "English" ? "Location Information" : "पत्ता माहिती"
            }</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Country:</label>
                <div class="value">${formData.country || ""}</div>
              </div>
              <div class="form-field">
                <label>State:</label>
                <div class="value">${formData.state || ""}</div>
              </div>
              <div class="form-field">
                <label>District:</label>
                <div class="value">${formData.district || ""}</div>
              </div>
              <div class="form-field">
                <label>Taluka:</label>
                <div class="value">${formData.taluka || ""}</div>
              </div>
              <div class="form-field">
                <label>Full Address:</label>
                <div class="value">${formData.address || ""}</div>
              </div>
              <div class="form-field">
                <label>Pincode:</label>
                <div class="value">${formData.pincode || ""}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${
              language === "English" ? "Contact Information" : "संपर्क माहिती"
            }</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Student Mobile No.:</label>
                <div class="value">${formData.mobileNo || ""}</div>
              </div>
              <div class="form-field">
                <label>Father's Mobile No.:</label>
                <div class="value">${formData.fMobile || ""}</div>
              </div>
              <div class="form-field">
                <label>Mother's Mobile No.:</label>
                <div class="value">${formData.mMobile || ""}</div>
              </div>
              <div class="form-field">
                <label>Aadhar Linked Mobile No.:</label>
                <div class="value">${formData.adharmobileNo || ""}</div>
              </div>
             
            </div>
             <div class="form-field">
                <label>Student Email ID:</label>
                <span class="value">${formData.stdemailId || ""}</span>
              </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${
              language === "English" ? "Parent's Occupation" : "पालकांची माहिती"
            }</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Father's Occupation:</label>
                <div class="value">${formData.fOccupation || ""}</div>
              </div>
              <div class="form-field">
                <label>Mother's Occupation:</label>
                <div class="value">${formData.mOccupation || ""}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${
              language === "English"
                ? "Education Information"
                : "शैक्षणिक माहिती"
            }</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Previous School:</label>
                <div class="value">${formData.prevSchool || ""}</div>
              </div>
              <div class="form-field">
                <label>Admission Class:</label>
                <div class="value">${formData.currentClass || ""}</div>
              </div>
              <div class="form-field">
                <label>Date of Admission:</label>
                <div class="value">${formData.dateOfAdmission || ""}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${
              language === "English" ? "Bank Information" : "बँकेची माहिती"
            }</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Account Holder Name:</label>
                <div class="value">${formData.accHolderName || ""}</div>
              </div>
              <div class="form-field">
                <label>Account Number:</label>
                <div class="value">${formData.accNo || ""}</div>
              </div>
              <div class="form-field">
                <label>Bank Name:</label>
                <div class="value">${formData.bankName || ""}</div>
              </div>
              <div class="form-field">
                <label>Branch Name:</label>
                <div class="value">${formData.branchName || ""}</div>
              </div>
              <div class="form-field">
                <label>IFSC Code:</label>
                <div class="value">${formData.IFSC || ""}</div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      setTimeout(() => printWindow.close(), 500);
    }, 300);
  };



 

  return (
    <div
      className="main-content-of-page"
      style={{
        maxWidth: "1600px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        backgroundColor: "#f8f9fa",
      }}
    >
      <AlertMessage message={alertMessage} show={showAlert} />

     <div
  style={{
    backgroundColor: "white",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    marginBottom: "20px",
    marginTop: "50px",
  }}
>
  <h1
    style={{
      color: "#143625",
      marginBottom: "20px",
      paddingBottom: "10px",
      borderBottom: "1px solid #eee",
      fontSize: "24px",
      fontWeight: "600",
    }}
  >
    Admission Management
  </h1>

  {udiseNumber && (
    <div style={{ marginTop: "20px" }}>
      <h3 style={{ color: "#34495e", marginBottom: "15px" }}>
        QR Code for Admission Form Link
      </h3>
      <div
        id="qrPrintSection"
        style={{
          textAlign: "center",
          padding: "20px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
      >
        <QRCodeCanvas
          id="qrCodeCanvas"
          value={`https://VedGurukul.cloud/admission-from?udise=${udiseNumber}`}
          size={200}
          bgColor="#ffffff"
          fgColor="#143625"
          level="H"
        />
        <p
          style={{
            marginTop: "15px",
            fontWeight: "600",
            color: "#7f8c8d",
          }}
        >
          For Admission Form, Scan the QR Code
        </p>
      </div>
    </div>
  )}

  <div
    style={{
      display: "flex",
      gap: "15px",
      marginBottom: "20px",
      flexWrap: "wrap",
    }}
  >
    <button
      onClick={() => {
        if (udiseNumber) {
          const link = `https://VedGurukul.cloud/admission-from?udise=${udiseNumber}`;
          navigator.clipboard
            .writeText(link)
            .then(() => setAlertMessage("Link copied to clipboard!"))
            .catch((err) => console.error("Failed to copy: ", err));
        }
      }}
      style={{
        padding: "10px 20px",
        backgroundColor: "#B22234",
        color: "white",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontWeight: "500",
        transition: "all 0.3s ease",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        minWidth: "120px",
      }}
      onMouseOver={(e) =>
        (e.currentTarget.style.backgroundColor = "#2980b9")
      }
      onMouseOut={(e) =>
        (e.currentTarget.style.backgroundColor = "#B22234")
      }
    >
      <i className="fas fa-copy" style={{ marginRight: "8px" }}></i>
      Copy Link
    </button>

    <button
      onClick={() => {
        const canvas = document.getElementById("qrCodeCanvas");
        if (canvas) {
          const dataUrl = canvas.toDataURL("image/png");
          const printWindow = window.open("", "_blank");
          printWindow.document.write(
            `<html>
              <head>
                <title>Print QR</title>
                <style>
                  body {
                    text-align: center;
                    font-family: Arial, sans-serif;
                    margin-top: 30px;
                  }
                  p {
                    font-size: 48px;
                    font-weight: bold;
                    margin-top: 150px;
                  }
                  img {
                    width: 500px;
                    height: 500px;
                  }
                </style>
              </head>
              <body>
                <img src="${dataUrl}" alt="QR Code" />
                <p>For Admission Form, Scan QR</p>
                <script>
                  window.onload = function() {
                    window.print();
                    window.onafterprint = function () {
                      window.close();
                    }
                  }
                </script>
              </body>
            </html>`
          );
          printWindow.document.close();
        }
      }}
      style={{
        padding: "10px 20px",
        backgroundColor: "#6c757d",
        color: "white",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontWeight: "500",
        transition: "all 0.3s ease",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        minWidth: "120px",
      }}
      onMouseOver={(e) =>
        (e.currentTarget.style.backgroundColor = "#5a6268")
      }
      onMouseOut={(e) =>
        (e.currentTarget.style.backgroundColor = "#6c757d")
      }
    >
      <i className="fas fa-print" style={{ marginRight: "8px" }}></i>
      Print QR
    </button>
  </div>

  {/* Redesigned Add New Class Section */}
  <div
  style={{
    backgroundColor: "#f8f9fa",
    padding: "20px",
    borderRadius: "12px",
    marginTop: "20px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  }}
>






  <h3
    style={{
      color: "#143625",
      marginBottom: "15px",
      fontSize: "18px",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    }}
  >
    <i className="fas fa-plus-circle" style={{ color: "#B22234" }}></i>
    Add New Class for addmission
  </h3>
  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
      flexWrap: "wrap",
    }}
  >
    <div style={{ position: "relative", flex: "0 1 250px" }}>
      <input
        type="text"
        value={newClass}
        onChange={(e) => setNewClass(e.target.value)}
        placeholder="Enter class name"
        list="classList"
        style={{
          padding: "12px 15px 12px 40px",
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
          width: "100%",
          fontSize: "14px",
          outline: "none",
          transition: "all 0.3s ease",
          boxShadow: "inset 0 1px 3px rgba(0,0,0,0.08)",
          backgroundColor: "white",
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#B22234";
          e.target.style.boxShadow = "0 0 0 2px rgba(52,152,219,0.2)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#e0e0e0";
          e.target.style.boxShadow = "inset 0 1px 3px rgba(0,0,0,0.08)";
        }}
      />
      <i
        className="fas fa-chalkboard-teacher"
        style={{
          position: "absolute",
          left: "15px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "#95a5a6",
          fontSize: "16px",
        }}
      ></i>
    </div>
    <datalist id="classList">
      {classes.map((classItem, index) => (
        <option key={index} value={classItem.name} />
      ))}
    </datalist>
    <button
      onClick={handleSaveClass}
      style={{
        padding: "12px 24px",
        backgroundColor: "#2ecc71",
        color: "white",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontWeight: "500",
        transition: "all 0.3s ease",
        boxShadow: "0 2px 8px rgba(46,204,113,0.3)",
        minWidth: "120px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.backgroundColor = "#27ae60";
        e.currentTarget.style.transform = "translateY(-1px)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.backgroundColor = "#2ecc71";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <i className="fas fa-save" style={{ marginRight: "8px" }}></i>
      Save
    </button>
  </div>
</div>
</div>

      <div
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          padding: "20px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
          marginBottom: "50px",
        }}
      >
        <h2
          style={{
            color: "#143625",
            marginBottom: "20px",
            paddingBottom: "10px",
            borderBottom: "1px solid #eee",
          }}
        >
          Admission Form List
        </h2>

        <input
          type="text"
          placeholder="Search by name, class, mobile, Aadhaar..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            marginBottom: "20px",
            padding: "12px 15px",
            width: "100%",
            border: "1px solid #ddd",
            borderRadius: "6px",
            fontSize: "16px",
            boxSizing: "border-box",
            transition: "all 0.3s",
            outline: "none",
          }}
          onFocus={(e) => (e.currentTarget.style.borderColor = "#B22234")}
          onBlur={(e) => (e.currentTarget.style.borderColor = "#ddd")}
        />

        {admissionData.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "40px",
              color: "#7f8c8d",
            }}
          >
            <i
              className="fas fa-inbox"
              style={{
                fontSize: "48px",
                marginBottom: "15px",
                color: "#bdc3c7",
              }}
            ></i>
            <h3 style={{ marginBottom: "10px" }}>No Admission Data Found</h3>
            <p>No admission forms have been submitted yet.</p>
          </div>
        ) : (
          <div
            style={{
              overflowX: "auto",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                backgroundColor: "white",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#143625",
                    color: "black",
                  }}
                >
                  <th
                    style={{
                      padding: "12px 15px",
                      textAlign: "left",
                      fontWeight: "500",
                    }}
                  >
                    Reg No
                  </th>
                  <th
                    style={{
                      padding: "12px 15px",
                      textAlign: "left",
                      fontWeight: "500",
                    }}
                  >
                    Student Name
                  </th>
                  <th
                    style={{
                      padding: "12px 15px",
                      textAlign: "left",
                      fontWeight: "500",
                    }}
                  >
                    Current Class
                  </th>
                  <th
                    style={{
                      padding: "12px 15px",
                      textAlign: "left",
                      fontWeight: "500",
                    }}
                  >
                    Mobile No
                  </th>
                  <th
                    style={{
                      padding: "12px 15px",
                      textAlign: "left",
                      fontWeight: "500",
                    }}
                  >
                    Aadhaar No
                  </th>
                  <th
                    style={{
                      padding: "12px 15px",
                      textAlign: "center",
                      fontWeight: "500",
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {admissionData
                  .filter(
                    (student) =>
                      student &&
                      student.stdName &&
                      student.currentClass &&
                      `${student.stdName} ${student.stdFather || ""} ${
                        student.stdSurname || ""
                      }`.trim() !== ""
                  )
                  .filter((student) => {
                    const query = searchQuery.toLowerCase();
                    const fullName = `${student.stdName} ${
                      student.stdFather || ""
                    } ${student.stdSurname || ""}`.toLowerCase();
                    return (
                      fullName.includes(query) ||
                      (student.currentClass || "")
                        .toLowerCase()
                        .includes(query) ||
                      (student.mobileNo || "").includes(query) ||
                      (student.stdAdharNo || "").includes(query)
                    );
                  })
                  .map((student, index) => (
                    <tr
                      key={student.id}
                      style={{
                        borderBottom: "1px solid #eee",
                        backgroundColor: index % 2 === 0 ? "white" : "#f8f9fa",
                      }}
                    >
                      <td
                        style={{
                          padding: "12px 15px",
                          color: "#143625",
                        }}
                      >
                        <input
                          type="text"
                          value={student.registerNo || ""}
                          onChange={(e) => handleRegisterNoChange(student.id, e.target.value)}
                          placeholder="Enter Reg No"
                          style={{
                            padding: "6px 10px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "14px",
                            width: "120px",
                            outline: "none",
                          }}
                        />
                      </td>
                      <td
                        style={{
                          padding: "12px 15px",
                          color: "#143625",
                        }}
                      >
                        <div style={{ fontWeight: "500" }}>
                          {student.stdName}
                        </div>
                        <div style={{ fontSize: "13px", color: "#7f8c8d" }}>
                          {student.stdFather} {student.stdSurname}
                        </div>
                      </td>
                      <td
                        style={{
                          padding: "12px 15px",
                          color: "#143625",
                        }}
                      >
                        {student.currentClass}
                      </td>
                      <td
                        style={{
                          padding: "12px 15px",
                          color: "#143625",
                        }}
                      >
                        {student.mobileNo || "-"}
                      </td>
                      <td
                        style={{
                          padding: "12px 15px",
                          color: "#143625",
                          fontFamily: "monospace",
                        }}
                      >
                        {student.stdAdharNo || "-"}
                      </td>
                      <td
                        style={{
                          padding: "12px 15px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            style={{
                              padding: "8px 15px",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontWeight: "500",
                              transition: "all 0.3s",
                              minWidth: "80px",
                            }}
                            onClick={() => printForm(student)}
                          >
                            View form
                          </button>

                          <button
                            onClick={() => handleSaveStudent(student)}
                            style={{
                              padding: "8px 15px",
                              backgroundColor: "#27ae60",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontWeight: "500",
                              transition: "all 0.3s",
                              minWidth: "80px",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#219653")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#27ae60")
                            }
                          >
                            <i
                              className="fas fa-save"
                              style={{ marginRight: "5px" }}
                            ></i>
                            Save
                          </button>

                          <button
                            onClick={() => handleRemoveStudent(student.id)}
                            style={{
                              padding: "8px 15px",
                              backgroundColor: "#e74c3c",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontWeight: "500",
                              transition: "all 0.3s",
                              minWidth: "80px",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#c0392b")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#e74c3c")
                            }
                          >
                            <i
                              className="fas fa-trash-alt"
                              style={{ marginRight: "5px" }}
                            ></i>
                            Remove
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdmissionData;